import { convertBase64ToUint8Array, convertUint8ArrayToBase64 } from '@ai-sdk/provider-utils';

const encoder = new TextEncoder();

export function toBase64(bytes: ArrayBuffer | Uint8Array) {
  if ((bytes as any).toBase64) {
    return (bytes as any).toBase64() as string;
  }

  const uint8Array = ArrayBuffer.isView(bytes) ? bytes : new Uint8Array(bytes);

  return convertUint8ArrayToBase64(uint8Array);
}

export function stringToBase64(contents: string) {
  return toBase64(encoder.encode(contents));
}

export function fromBase64(b64: string) {
  if ((Uint8Array as any).fromBase64) {
    return (Uint8Array as any).fromBase64(b64) as Uint8Array;
  }

  return convertBase64ToUint8Array(b64);
}

export function toBase64Url(bytes: ArrayBuffer | Uint8Array) {
  return toBase64(bytes).replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, '');
}

export function stringToBase64Url(contents: string) {
  return stringToBase64(contents).replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, '');
}
